// ============================================================================
// FIBONACCI SEARCH - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'fibonacci-search',
  name: 'Fibonacci Search',
  category: 'Search',
  complexity: {
    time: 'O(log n)',
    space: 'O(1)'
  },
  description: 'Fibonacci Search uses Fibonacci numbers to divide the sorted array. It has O(log n) time complexity and uses only addition/subtraction operations.'
};
export type MetaType = typeof meta;
